<section class="section section-shaped">
  <div class="container">
    <div class="text-primary text-underline cursor-pointer back-button h5" (click)="back()">
      {{ 'common.back' | translate }}
    </div>
    <div class="title text-center">{{ 'campaign.campaignDetails' | translate }}</div>
    @if (!isLoading) {
      <app-campaign-info [campaignInfo]="campaignInfo" [tabs]="campaignMenus"> </app-campaign-info>
    }
    @if (isLoading) {
      <agmo-loading></agmo-loading>
    }
  </div>
</section>
